/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InventoryDTOFromJSON, InventoryDTOToJSON, } from './InventoryDTO';
import { InventorySnapshotResponseDTOFromJSON, InventorySnapshotResponseDTOToJSON, } from './InventorySnapshotResponseDTO';
/**
 * Check if a given object implements the OrderItemResponseDTO interface.
 */
export function instanceOfOrderItemResponseDTO(value) {
    return true;
}
export function OrderItemResponseDTOFromJSON(json) {
    return OrderItemResponseDTOFromJSONTyped(json, false);
}
export function OrderItemResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'amazonOrderItemId': json['amazonOrderItemId'] == null ? undefined : json['amazonOrderItemId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sellerSku': json['sellerSku'] == null ? undefined : json['sellerSku'],
        'title': json['title'] == null ? undefined : json['title'],
        'quantityOrdered': json['quantityOrdered'] == null ? undefined : json['quantityOrdered'],
        'quantityShipped': json['quantityShipped'] == null ? undefined : json['quantityShipped'],
        'itemPrice': json['itemPrice'] == null ? undefined : json['itemPrice'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'carrier': json['carrier'] == null ? undefined : json['carrier'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'taxCollectionModel': json['taxCollectionModel'] == null ? undefined : json['taxCollectionModel'],
        'snapshot': json['snapshot'] == null ? undefined : InventorySnapshotResponseDTOFromJSON(json['snapshot']),
        'detailSnapshot': json['detailSnapshot'] == null ? undefined : InventoryDTOFromJSON(json['detailSnapshot']),
        'desiLbs': json['desiLbs'] == null ? undefined : json['desiLbs'],
        'chargeableWeightLbs': json['chargeableWeightLbs'] == null ? undefined : json['chargeableWeightLbs'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
    };
}
export function OrderItemResponseDTOToJSON(json) {
    return OrderItemResponseDTOToJSONTyped(json, false);
}
export function OrderItemResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'amazonOrderId': value['amazonOrderId'],
        'amazonOrderItemId': value['amazonOrderItemId'],
        'asin': value['asin'],
        'sellerSku': value['sellerSku'],
        'title': value['title'],
        'quantityOrdered': value['quantityOrdered'],
        'quantityShipped': value['quantityShipped'],
        'itemPrice': value['itemPrice'],
        'currencyCode': value['currencyCode'],
        'carrier': value['carrier'],
        'trackingNumber': value['trackingNumber'],
        'taxCollectionModel': value['taxCollectionModel'],
        'snapshot': InventorySnapshotResponseDTOToJSON(value['snapshot']),
        'detailSnapshot': InventoryDTOToJSON(value['detailSnapshot']),
        'desiLbs': value['desiLbs'],
        'chargeableWeightLbs': value['chargeableWeightLbs'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
    };
}
